import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import view_icon from "../../assets/images/view_icon.svg";
import edit_icon from "../../assets/images/edit_icon.svg";
import delete_icon from "../../assets/images/delete_icon.svg";
import copy_icon from "../../assets/images/copy_icon.svg";
import DeletePopup from "../popups/DeletePopup";
import {
  deleteEmployee,
  createEmployee,
  fetchEmployeeById,
  fetchAllEmployees,
} from "../../store/slices/userSlice";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import ProfileDetail from "../layout/ProfileDetail";
import { formatDate, formatCurrency } from "../../utils/dateUtils";
import user from "../../assets/images/User.png";
import { encryptBankingData } from "../../utils/cryptoUtils";

const EmploayeListTable = ({
  data = [],
  isDetailPage = false,
  loading = false,
  currentPage,
  pageSize,
  totalRecords,
  onPageChange,
  pageKey,
  onRefresh,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [copyLoading, setCopyLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const totalPages = Math.ceil(totalRecords / pageSize);

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (selectedItem?.id) {
      dispatch(deleteEmployee({ id: selectedItem.id, key: pageKey }));
      setShowDeleteModal(false);
      setSelectedItem(null);
    }
  };

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const formatPrettyDate = (dateString) => {
    return formatDate(dateString);
  };

  const openProfile = (item) => {
    setSelectedUserId(item.id);
    setShowProfileModal(true);
  };

  const handleCopyEmployee = async (item) => {
    try {
      setCopyLoading(true);

      const response = await dispatch(
        fetchEmployeeById({
          id: item.id,
          key: "copyEmployee",
        }),
      ).unwrap();

      const employee = response.data;

      const formData = new FormData();

      const randomNo = Math.floor(10 + Math.random() * 90);

      formData.append("name", `${employee.name} Copy ${randomNo}`);

      formData.append("email", `copy${randomNo}_${employee.email}`);
      formData.append("phone", employee.phone || "");

      formData.append("companyUserId", employee.companyUserId || 0);
      formData.append("departmentId", employee.departmentId || 0);
      formData.append("designationId", employee.designationId || 0);

      formData.append("joiningDate", employee.joiningDate || "");
      formData.append("payAvg", employee.payAvg || 0);

      formData.append("isActive", employee.isActive);

      formData.append("countryId", employee.countryId || 0);
      formData.append("stateId", employee.stateId || 0);
      formData.append("cityId", employee.cityId || 0);

      formData.append("address", employee.address || "");
      formData.append("zipCode", employee.postalCode || "");

      const encryptedBankingData = await encryptBankingData({
        bankHolderName: "TName",
        bankName: "Test Bank",
        accountNumber: "ice123456",
        routingNumber: "011401533",
        description: "primary",
      });

      formData.append(
        "SaveBankDTO.BankHolderName",
        encryptedBankingData.EncryptedBankHolderName,
      );

      formData.append(
        "SaveBankDTO.BankName",
        encryptedBankingData.EncryptedBankName,
      );

      formData.append(
        "SaveBankDTO.AccountNumber",
        encryptedBankingData.EncryptedAccountNumber,
      );

      formData.append(
        "SaveBankDTO.RoutingNumber",
        encryptedBankingData.EncryptedRoutingNumber,
      );

      formData.append(
        "SaveBankDTO.Description",
        encryptedBankingData.EncryptedDescription,
      );

      formData.append("SaveBankDTO.AccountType", "C");
      await dispatch(createEmployee(formData)).unwrap();

      if (onRefresh) {
        await onRefresh();
      }

      setCopyLoading(false);
    } catch (error) {
      setCopyLoading(false);

      alert(error?.message || error || "Failed to copy employee");
    }
  };

  var BaseURL = process.env.REACT_APP_IMAGE_BASE_URL || "";

  return (
    <>
      {copyLoading && (
        <div className="copy_loader_overlay">
          <div className="copy_loader_box">Copying Employee...</div>
        </div>
      )}

      <div className="custom_table table-responsive">
        <div className="table-wrapper">
          <table className="table mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone No.</th>
                {!isDetailPage && <th>Company</th>}
                <th>Department</th>
                <th>Designation</th>
                <th>Date Of Joining</th>
                <th>Pay Avg</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="user_img mr_10">
                            <img
                              src={
                                item?.profile !== null
                                  ? BaseURL + item.profile
                                  : user
                              }
                              alt="user"
                            />
                          </div>
                          {item.name}
                        </div>
                      </td>
                      <td
                        className="truncated-text"
                        data-full-text={item.email}
                      >
                        {item.email && item.email.length > 30
                          ? item.email.substring(0, 30) + "..."
                          : item.email}
                      </td>
                      <td>{item.phone || "-"}</td>
                      {!isDetailPage && <td>{item.companyName || "-"}</td>}
                      <td>{item.department || "-"}</td>
                      <td>{item.designation || "-"}</td>
                      <td>{formatPrettyDate(item.joiningDate)}</td>
                      <td>{formatCurrency(item.payAvg)}</td>
                      <td>
                        <div className={item.isActive ? "active" : "inactive"}>
                          {item.isActive ? "Active" : "Inactive"}
                        </div>
                      </td>
                      <td>
                        <div className="action_links">
                          <span
                            className="icon_btn"
                            role="button"
                            title="View"
                            onClick={() => openProfile(item)}
                          >
                            <img src={view_icon} alt="view" />
                          </span>
                          <span style={{ cursor: "pointer" }}>
                            <img
                              src={edit_icon}
                              alt="edit"
                              onClick={() =>
                                navigate(`/editemployee`, {
                                  state: {
                                    id: item.id,
                                    from: location.pathname,
                                  },
                                })
                              }
                            />
                          </span>
                          <span
                            style={{ cursor: "pointer" }}
                            title="Copy Employee"
                            onClick={() => handleCopyEmployee(item)}
                          >
                            <img src={copy_icon} alt="copy" />
                          </span>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDelete(item);
                            }}
                          >
                            <img src={delete_icon} alt="delete" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No employees found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION FOOTER */}
        {totalRecords > 0 && (
          <div className="table_footer">
            <div className="footer_left">
              Showing {(currentPage - 1) * pageSize + 1}–
              {Math.min(currentPage * pageSize, totalRecords)} of {totalRecords}{" "}
              entries
            </div>

            <div className="footer_right">
              <button
                className="page_btn"
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
              >
                ‹ Previous
              </button>

              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`page_btn ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                  onClick={() => onPageChange(i + 1)}
                >
                  {String(i + 1).padStart(2, "0")}
                </button>
              ))}

              <button
                className="page_btn"
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
              >
                Next ›
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Delete Popup */}
      <DeletePopup
        show={showDeleteModal}
        type="Employee"
        handleClose={() => setShowDeleteModal(false)}
        onDelete={confirmDelete}
        allowedNames={selectedItem ? [selectedItem.name] : []}
      />

      {selectedUserId && (
        <ProfileDetail
          show={showProfileModal}
          onClose={() => {
            setShowProfileModal(false);
            setSelectedUserId(null);
          }}
          type="employee"
          clientId={selectedUserId}
        />
      )}
    </>
  );
};

export default EmploayeListTable;
